export default "__VITE_ASSET__DCMrbI$6__"